<template>
  <div id="singleFlock" class="componentWrapper grid grid__item_span-12 m0 p0 profile" @click="listenOut">

    <div id="menuBar" v-if="!mobileClass">
       <router-link to="/theflock">
        <img id="goBack" src="../assets/icons/dark-arrow.png" /></p>
      </router-link>
    </div>

    <!-- LEFT COLUMN -->
    <div id="profileImage" class="grid grid__item_span-5 m0" :style="'background-image: url(' + page.image + ')'">
    </div>

    <!-- RIGHT COLUMN / profile text -->
    <div id="profileDetails" class="grid grid__item_span-5 p0 m0 grid__item_alignCenter">
      <div id="backgroundLetters">
        <div v-for="(svgs, index) in page.svgsContainer" :id="'letter-' + index" :letter-attr="svgs.svg_file.title">
          <img :src="svgs.svg_file.url" :title="page.title" :alt="page.title" draggable="false"/>
        </div>
      </div>
      <div id="details" class="grid__item_span-9 txtBlack">
        <!--{{this.$route.params.slug}}-->
        <div class="about" v-html="page.about"></div>

      </div>

      <div id="menuBar" v-if="mobileClass">
         <router-link to="/theflock">
          <img id="goBack" src="../assets/icons/dark-arrow.png" /></p>
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>

import menuTransitions from '../assets/js/menu.js'
import Axios from 'axios'
require('../assets/js/settings.js')

export default {
  name: 'Profile',
  data () {
    return {
      metaTitle: '',
      metaDescription: '',
      mobileClass: '',
      page: {}
      // siteURL: window.url
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      meta: [
        { vmid: 'description', name: 'description', content: this.metaDescription }
      ]
    }
  },
  methods: {
    mobileDetect () {
      var browserSize = window.innerWidth || document.body.clientWidth
      var deviceMaxSize = 1024
      if (browserSize < deviceMaxSize) {
        this.mobileClass = 'deviceActive'
      }
    },
    getData () {
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/theflock/?slug=' + this.$route.params.slug).then(response => {
        this.metaTitle = response.data[0].acf.meta_title
        this.metaDescription = response.data[0].acf.meta_description
        var page = {
          title: response.data[0].title.rendered,
          firstName: response.data[0].acf.first_name,
          about: response.data[0].acf.about_you,
          phone: response.data[0].acf.phone,
          mobile: response.data[0].acf.mobile,
          email: response.data[0].acf.email,
          image: response.data[0].acf.profile_shot.url,
          svgsContainer: response.data[0].acf.svgs
        }
        this.page = page
        // console.log(response.data[0])
      }).catch(function (error) {
        console.log(error)
      })
    },
    howManyChild: function () {
      setTimeout(function () {
        var lettersParent = document.getElementById('backgroundLetters')
        var countChildren = lettersParent.childNodes.length

        if (countChildren === 4) {
          lettersParent.classList.add('fourChildren')
        } else if (countChildren === 5) {
          lettersParent.classList.add('fiveChildren')
        } else if (countChildren === 6) {
          lettersParent.classList.add('sixChildren')
        } else if (countChildren === 7) {
          lettersParent.classList.add('sevenChildren')
        } else if (countChildren === 8) {
          lettersParent.classList.add('eightChildren')
        }
      }, 500)
    },
    listenOut () { // this is the function which closes the menu
      // console.log('ready')
      menuTransitions.hideHeader()
    }
  },
  mounted () {
    // Hide the bsdText div until we scroll
    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0
    // this.setURL()

    this.howManyChild()
    this.mobileDetect()

    setTimeout(function () {
      document.getElementById('menuBar').classList.add('active')
    }, 1000)
  },
  created () {
    // menuTransitions.openMenu()
    this.getData()
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #profileImage{
    background-position: 50% 0;
    background-repeat: no-repeat;
    background-size: cover;
  }

</style>



// WEBPACK FOOTER //
// src/components/profile.vue